import { QueryKey } from '@tanstack/react-query'
import { ListingCampaignModel } from 'types/rex'
import RexService from 'services/rexService'

const GetListingByCampaignId = async (
  { queryKey }: { queryKey: QueryKey },
  getAuthToken: () => Promise<string>
): Promise<ListingCampaignModel | undefined> => {
  const token = await getAuthToken()

  const campaignId = queryKey[1] as string
  const service = new RexService(token)

  const params: { campaignId: string } = {
    campaignId,
  }

  const result = await service.rexService.get('GetListingByCampaignId', params)

  return result.data
}

export default GetListingByCampaignId
